import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import moment from "moment-timezone";
export default {
    namespaced: true,
    state: {
        football:[],
        disabled:true,
    },
    mutations: {
        setFootball(state:any, result:any) {
            state.football = result
        },
        setDisabled(state:any, result:any) {
            state.disabled = result
        },
    },
    actions: {
        async getData({ commit}: any, userId){
            const selected:any = [];
            await firebase.firestore().collection("football_play").doc(userId).get().then((doc) => {
                if(doc.exists){
                    const data:any = doc.data();
                    if(data.selected){
                        for(const x in data.selected){
                            selected[data.selected[x].key] = data.selected[x].value;
                        }
                    }
                }
            });
            console.log(Object.entries(selected).length);
            if (Object.entries(selected).length != 0) {
                commit('setDisabled', true)
            }
            firebase.firestore().collection("football").get().then((snapshot) => {
                const football:firebase.firestore.DocumentData[] = [];
                snapshot.forEach((doc) => {
                  const data = doc.data();
                  data.key = doc.id;
                  if(selected[data.key])
                    data.selected = selected[data.key];
                  else
                    data.selected = 0;
                  football.push(data);
                });
                commit('setFootball', football)
                
            }); 
        },
        setSelected({commit,state}:any, {index,selected}){
            const data = state.football;
            data[index].selected = selected;
        },
        async saveFootball({commit,state}:any, userId){
            const data = state.football;
            const value:any[] = [];
            for(const x in data){
                value.push({
                    key:data[x].key,
                    value:data[x].selected
                });
            }
            return new Promise(( res, rej ) => {
                firebase.firestore().collection('football_play').doc(userId).set({
                    userId,
                    selected:value,
                    createdate: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss")
                }).then(()=>{
                    res();
                });
            });
        }
    },
    getters: {
        football: ({football}) => {
            return football
        },
        disabled: ({disabled}) => {
            return disabled
        }
    }
}